/// Appelé uniquement sur la page de coordonnees des listes mariages, pacs et cadeaux
/// /liste-cadeaux/creation-liste-[TypeList]
class Recap extends ListeMariage {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize(idFormulaire) {
		let self = this;

		super.initialize();

		const form = new Formulaire(settings);
		form.initialize(idFormulaire);
	}
}